import { render, staticRenderFns } from "./CandidateContacts.vue?vue&type=template&id=7da1d652&scoped=true"
import script from "./CandidateContacts.vue?vue&type=script&lang=js"
export * from "./CandidateContacts.vue?vue&type=script&lang=js"
import style0 from "./CandidateContacts.vue?vue&type=style&index=0&id=7da1d652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da1d652",
  null
  
)

export default component.exports